import { useEffect, useState } from "react";
import { BRAND, NAV_LINKS } from "@/data/content";

export const SiteNav = ({ show }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className={`nav ${show ? "show" : ""} ${scrolled ? "scrolled" : ""}`} data-testid="site-nav">
      <a className="nav-logo" href="#top" data-testid="nav-logo" onClick={go("top")}>
        Myst<span> Music</span>
      </a>
      <nav className="nav-links">
        {NAV_LINKS.map((l) => (
          <a key={l.target} href={`#${l.target}`} data-testid={`nav-link-${l.target}`} onClick={go(l.target)}>
            {l.label}
          </a>
        ))}
        <a className="nav-go" href="#contact" data-testid="nav-book" onClick={go("contact")}>
          Book
        </a>
      </nav>
    </header>
  );
};
